export default "__VITE_ASSET__4a0d27e3__"